const GroupedRequestedProductColumn = [
    {
        Label: () => 'Nombre',
        Component: ({ value }) => `${value?.name}`
    },
    {
        Label: () => 'Cantidad',
        Component: ({ value }) => `${value?.quantity}`
    },
    {
        Label: () => 'Precio unitario',
        Component: ({ value }) => `$ ${value?.unit_price?.toLocaleString()}`
    },
    {
        Label: () => 'Total',
        Component: ({ value }) => `$ ${value?.price?.toLocaleString()}`
    },
    {
        Label: () => 'Estado',
        Component: ({ value }) => <div className={`btn btn-xs btn-${value?.status_variant_color}`} >
            {value?.status_name}
        </div>
    },
    {
        Label: () => 'Proveedor',
        Component: ({ value }) => value?.provider_name
    },
];

export default GroupedRequestedProductColumn;

